import React from 'react';

import PropTypes from 'prop-types';

import theme, { StylableComponent } from '@adsk/alloy-react-theme';

type Props = StylableComponent<HTMLDivElement>;

const Body = ({ style, className, children, ...props }: Props) => (
  <div
    {...props}
    className={className}
    css={[
      {
        flex: 1,
        overflow: 'auto',
        padding: `10px ${theme.spacing.L}px`,
      },
      style,
    ]}
  >
    {children}
  </div>
);

Body.propTypes = {
  /** The content of modal */
  children: PropTypes.any,
  /** Styles applied to the root element */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  /** Class applied to the root element */
  className: PropTypes.string,
};

export default Body;
